export default function secureLink(link) {
  return link ? link.replace('http:', 'https:') : link
}
